import React from 'react';
import NextLink from 'next/link';
import { GIA_LOOKUP_HREF } from './market-pages';

export const GiaLookupLink = ({ className = '' }: { className?: string }) => (
  <NextLink href={GIA_LOOKUP_HREF} prefetch={false}>
    <a className={`tw-inline-flex tw-min-h-[40px] tw-shrink-0 tw-items-center tw-justify-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-md tw-border tw-border-[#146557] tw-bg-[#146557] tw-px-2.5 tw-py-2 tw-text-[12px] sm:tw-text-[13px] tw-font-medium tw-text-white hover:tw-bg-[#0D5145] hover:tw-text-white focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#A68A59] ${className}`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="tw-hidden sm:tw-block tw-h-4 tw-w-4 tw-shrink-0" aria-hidden="true"><path d="M5 3h9l5 5v13H5V3Z" /><path d="M14 3v5h5M8 12h8m-8 4h5" /></svg>
      Tra cứu GIA
    </a>
  </NextLink>
);
